import "./Footer.css";

const Footer = () => {
  return (
    <footer id="footer">
      <a href="https://github.com/VioletCutler">[ Github ]</a>
      <a href="https://www.linkedin.com/in/violetcutler/">[ LinkedIn ]</a>
    </footer>
  );
};

export default Footer;
